import { client } from '@hotjar/api-base-client';
import { api as legacyPaymentMethodApi } from '@hotjar/webapp/billing/paymentMethod';
import { fromUnixTime } from 'date-fns';
import type { CreditCardType } from '../common/model/customer';
import type { CurrentUserResponseDto } from './dto';
import { getCustomer } from './get-customer';
import { mapCurrentUserDtoToUser } from './mapper';
import type { SubscriptionInfo, User } from './model';

export async function getSubscriptionInfo(): Promise<SubscriptionInfo> {
  /**
   * we get the current user directly until there is a common space for getting it that is not legacy
   * TODO: future person... if you read this comment and it is possible to get the current user without
   * introducting circular dependencies, please stop staring at this comment and get to work replacing this
   */
  const user = await client<User, CurrentUserResponseDto>({
    url: `/api/v2/users/me`,
    mapResponseData: mapCurrentUserDtoToUser,
  });

  /**
   * if there is no subscribed customer the server returns an error
   * so here we return null and treat it as a non paying user
   */
  const customer = await getCustomer(user.accountId).catch(() => null);

  // Please remove this this if statement once all customers have migrated their payment methods to B3.0
  if (customer?.paymentMethod.paymentMethodType === 'HOTJAR_BRAINTREE_PAYMENT_METHOD') {
    const legacyPaymentMethod = await legacyPaymentMethodApi
      .get({ id: customer.hotjarAccountId })
      .catch(() => null);

    if (legacyPaymentMethod?.type === 'credit_card') {
      const expirationDate = fromUnixTime(legacyPaymentMethod.expiryDate);

      customer.paymentMethod = {
        paymentMethodType: 'CREDIT_CARD',
        details: {
          cardNumber: `************${legacyPaymentMethod.label}`,
          expirationMonth: expirationDate.getMonth() + 1,
          expirationYear: expirationDate.getFullYear(),
          creditCardType: 'Card' as CreditCardType,
        },
      };
    } else if (legacyPaymentMethod?.type === 'paypal') {
      customer.paymentMethod = {
        paymentMethodType: 'PAYPAL',
        details: {
          email: legacyPaymentMethod.label,
        },
      };
    }
  }

  return {
    customer,
    user,
  };
}
